import { render, staticRenderFns } from "./ResendNotif.vue?vue&type=template&id=56ac32b2&lang=pug"
import script from "./ResendNotif.vue?vue&type=script&lang=js"
export * from "./ResendNotif.vue?vue&type=script&lang=js"
import style0 from "./ResendNotif.vue?vue&type=style&index=0&id=56ac32b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports